export default "__VITE_ASSET__BNALpTZH__"